import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import Lottie from 'lottie-react';

// Context //
import { useLanguage } from '../../../Context/LanguageContext';
// Context //

// Model //
import CalculationFomulaModal from './CalculationFormulaModal';
import MemberList from './MemberList';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

// Image // 
import Duration from '../../../image/DurationImage.png';
import NewImage from '../../../image/NewImage.png';
// Image // 

const MaintainMemberAndNewMemberView = (props) => {
  const {
    allMembers,
    salesData,
    startDate,
    endDate,
    calcDateText,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isLoadingAllMember,
    isAliveLoading,
    setIsAliveLoading,
    durationSum,
    durationAvg,
    durationMembers,
    isDurationLoading
  } = props;

  const history = useHistory();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [newMembers, setNewMembers] = useState([]);
  const [newMemberPrice, setNewMemberPrice] = useState(0);
  const [isViewDurationModal, setIsViewDurationModal] = useState(false);

  // 신규 등록 회원 구분 //
  useEffect(() => {
    if (isLoadingAllMember) return;

    let newMembers = [];

    for (let i = 0; i < allMembers.length; i++) {
      let isReregist = false;

      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].startDate) || startDate.isSame(allMembers[i].usages[j].startDate))
          && (endDate.isAfter(allMembers[i].usages[j].startDate) || endDate.isSame(allMembers[i].usages[j].startDate))
          && allMembers[i].usages.length <= 1) {
          allMembers[i].startDate = allMembers[i].usages[j].startDate;
          isReregist = true;
          break;
        }
        // else isReregist = false;
      }

      if (isReregist) newMembers.push(allMembers[i]);
    }


    setNewMembers(newMembers);

    setTimeout(() => {
      setIsAliveLoading(false);
    }, 1000)
  }, [startDate, endDate, allMembers, isLoadingAllMember])


  useEffect(() => {
    if (salesData.length === 0 || allMembers.length === 0) return;

    let newMembers = [];
    let newMemberPrice = 0;

    for (let i = 0; i < allMembers.length; i++) {
      for (let j = 0; j < allMembers[i].usages.length; j++) {
        if ((startDate.isBefore(allMembers[i].usages[j].approvalDate) || startDate.isSame(allMembers[i].usages[j].approvalDate))
          && (endDate.isAfter(allMembers[i].usages[j].approvalDate) || endDate.isSame(allMembers[i].usages[j].approvalDate))
          && allMembers[i].usages.length <= 1) {
          newMembers.push(allMembers[i]);
          break;
        }
      }
    }
    for (let i = 0; i < salesData.length; i++) {
      let isExist = false;
      for (let j = 0; j < newMembers.length; j++) {
        if (salesData[i].memberId === newMembers[j].memberId) {
          isExist = true;
          break;
        }
      }

      if (isExist) {
        newMemberPrice += (salesData[i].cardPrice + salesData[i].cashPrice);
      }

    }

    setNewMemberPrice(newMemberPrice);
  }, [salesData, allMembers])

  // 전화번호 표시 //
  function calcPhoneView(phone) {
    if (!phone || phone === '') return t('statistics.noPhone');
    return phone;
  }

  // 장기 지속일 표시 //
  function calcDuration(data) {
    if (data < 1) return t('statistics.maintainMember.totalMonths1');
    else {
      if (data < 10) return t('statistics.maintainMember.durationPrefix') + '0' + Math.floor(data) + t('statistics.monthUnit');
      else return t('statistics.maintainMember.durationPrefix') + Math.floor(data) + t('statistics.monthUnit');
    }
  }

  // 평균 회원 유지일 호버링시 //
  function onMouseOverDuration() {
    setIsViewDurationModal(true);
  }

  // 평균 회원 유지일 호버링시 //
  function onMouseLeaveDuration() {
    setIsViewDurationModal(false);
  }

  // 회원 클릭시 페이지 넘기기 //
  function onClickDurationMember(memberId) {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/member/valid/detail/' + memberId);
    else history.push('/member/partner_gym/detail/' + memberId);
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' ' + t('statistics.maintainMember.avgMemberRetention')}</Text>
        {
          isDurationLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <DurationImage src={Duration} />
                      <DurationColorTextBox
                        backgroundColor='#6DD49E'
                        onMouseOver={onMouseOverDuration}
                        onMouseLeave={onMouseLeaveDuration}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} hover='pointer'>{t('statistics.maintainMember.avgRetentionDays')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} hover='pointer'>{durationAvg}{t('statistics.monthUnit')}</Text>
                      </DurationColorTextBox>
                      <CalculationFomulaModal
                        isView={isViewDurationModal}
                        denominator={durationSum.toLocaleString('ko-KR')}
                        denominatorText={t('statistics.maintainMember.formulaNumerator')}
                        numerator={durationMembers.length.toLocaleString('ko-KR')}
                        numeratorText={t('statistics.maintainMember.formulaDenominator')}
                        result={durationAvg}
                        resultUnit={t('statistics.monthUnit')}
                        innerBoxBackgroundColor='#407E67'
                        componentBoxBackgroundColor='#53B38F' />
                      <DivisionLine />
                      <ResultBox/>
                    </TopUIWrapper>
                    <DurationMemberBoxWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.longTermMemberList')}</Text>
                      <DurationMemberBox>
                        <DurationMemberColumn>
                          <Text style={{ marginRight: `40px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.colName')}</Text>
                          <Text style={{ marginRight: `29px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.colGender')}</Text>
                          <Text style={{ marginRight: `46px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.colBirth')}</Text>
                          <Text style={{ marginRight: `49px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.colPhone')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.colLongTermDays')}</Text>
                        </DurationMemberColumn>
                        <DurationMemberList>
                          {
                            durationMembers.map((data, index) => (
                              <DurationMemberWrapper key={index} onClick={() => onClickDurationMember(data.memberId)}>
                                <DurationNameBox>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.name}</Text>
                                </DurationNameBox>
                                <DurationGenderBox>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.gender === 'male' ? t('statistics.male') : t('statistics.female')}</Text>
                                </DurationGenderBox>
                                <DurationBirthBox>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.birthDay.slice(0, 4) + '.' + data.birthDay.slice(4, 6) + '.' + data.birthDay.slice(6, 8)}</Text>
                                </DurationBirthBox>
                                <DurationPhoneBox>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{calcPhoneView(data.phone)}</Text>
                                </DurationPhoneBox>
                                <DurationContentBox>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{calcDuration(data.duration)}</Text>
                                </DurationContentBox>
                              </DurationMemberWrapper>
                            ))
                          }
                        </DurationMemberList>
                      </DurationMemberBox>
                    </DurationMemberBoxWrapper>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{calcDateText() + ' ' + t('statistics.maintainMember.newRegisteredMembers')}</Text>
        {
          isAliveLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <LeaveIcon src={NewImage} />
                      <ReRegistrationPersent>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} hover='default'>{t('statistics.maintainMember.newRegisteredMemberCount')}</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} hover='default'>{newMembers.length}{t('statistics.personUnit')}</Text>
                      </ReRegistrationPersent>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.newRegisteredMemberCount')}</Text>
                      <PriceTextWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('statistics.maintainMember.newMemberSales')}</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{newMemberPrice.toLocaleString('ko-KR')}</Text>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('statistics.won')}</Text>
                      </PriceTextWrapper>
                    </ListTitleWrapper>
                    <MemberList column={t('statistics.memberMovement.registrationDate')} data={newMembers} selectedPartnerGym={selectedPartnerGym} />
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default MaintainMemberAndNewMemberView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 38px;

  width: 1020px;
  height: 448px;

  gap: 28px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const BoxDivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: ${props => props.theme.line};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 454px;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 364px;

  z-index: 5;

  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const TopUIWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const LeaveIcon = styled.img`
  width: 35px;
  height: 36px;

  margin-right: 8px;
`;

const ReRegistrationPersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: ${props => props.theme.pointYellow};
`;

const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 24px;

  width: 100%;
`;

const ImageBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 24px;

  gap: ${props => props.gap}px;
`;

const DurationImage = styled.img`
  width: 43px;
  height: 46px;

  margin-right: 8px;
`;

const DurationColorTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 9px;

  width: 187px;
  height: 28px;
  
  gap: 4px;

  border-radius: 8px;
  background-color: #53B38F;

  &:hover {
    cursor: pointer;
  }
`;

const DurationMemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 24px;
`;

const DurationMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 454px;
  height: 240px;
`;

const DurationMemberColumn = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px;

  width: calc(100% - 16px);
  height: 32px;

  border-radius: 8px 8px 0 0;
  background-color: ${props => props.theme.line};
`;

const DurationMemberList = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 216px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: ${props => props.theme.subackground};
		border-radius: 200px;
	}
`;

const DurationMemberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px;

  gap: 8px;

  width: calc(100% - 16px);
  min-height: 36px;
  max-height: 36px;

  background-color: ${props => props.theme.subBackground};

  &:hover {
    background-color: ${props => props.theme.background};
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const DurationNameBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 59px;
  height: 20px;

  overflow: hidden;
`;

const DurationGenderBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 46px;
  height: 20px;

  overflow: hidden;
`;

const DurationBirthBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 90px;
  height: 20px;

  overflow: hidden;
`;

const DurationPhoneBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 106px;
  height: 20px;

  overflow: hidden;
`;

const DurationContentBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 101px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;

const PriceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  gap: 4px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;


const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 120px;
  height: 1px;

  margin: 0 16px 0 16px;
`;

const ResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 28px;
`;
